import styled from 'styled-components';

export const TableStyle = styled.div`
  th.ant-table-cell {
    white-space: nowrap;
  }

  .ant-table-cell {
    p {
      max-width: 100%;
      word-wrap: break-word;
      white-space: break-spaces;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      line-clamp: 3;
      -webkit-line-clamp: 3;
      margin: 0;
    }

    .path {
      max-width: 250px;
    }

    .link {
      max-width: 250px;
      color: #0c3255;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }

    &.min-w-200 {
      min-width: 200px;
    }
  }

  .ant-table {
    .ant-table-tbody {
      .action-box {
        display: flex;
        gap: 5px;
        .ant-btn {
          color: #ffffff;
          border: none;
        }
      }
    }
  }
  .ant-table {
    border: 1px solid #f0f0f0;
  }

  .ant-table-thead > tr > th {
    font-weight: bold;
  }
  .ant-table-tbody {
    .ant-table-row {
      background-color: #ffffff;
    }
  }
  .ant-table-tbody > tr > td {
    padding: 12px;
  }

  .ant-table-pagination {
    margin-top: 16px;
  }
`;
